import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  overViewSiteMetrics: {
    pastDue: 0,
    inProgress: 0,
    completed: 0,
    total: 0,
  },
  overViewOrderMetrics: {
    pastDue: 0,
    inProgress: 0,
    completed: 0,
    total: 0,
  },
  isSiteMetricsLoading: true,
  isOrderMetricsLoading: true,
  isOrderProgressStatusLoading: true,
}

const sitesOverviewSlice = createSlice({
  name: 'sitesOverview',
  initialState,
  reducers: {
    setOverviewSiteMetrics: (state, action) => {
      state.overViewSiteMetrics = action.payload
    },
    setOverviewOrderMetrics: (state, action) => {
      state.overViewOrderMetrics = action.payload
    },

    setIsSitesMetricsLoading: (state, action) => {
      state.isSiteMetricsLoading = action.payload
    },
    setIsOrderMetricsLoading: (state, action) => {
      state.isOrderMetricsLoading = action.payload
    },
    setIsOrderProgressStatusLoading: (state, action) => {
      state.isOrderProgressStatusLoading = action.payload
    },
  },
})

export const {
  setOverviewSiteMetrics,
  setOverviewOrderMetrics,
  setIsSitesMetricsLoading,
  setIsOrderMetricsLoading,
  setIsOrderProgressStatusLoading,
} = sitesOverviewSlice.actions

export default sitesOverviewSlice.reducer
